import React from 'react';

interface AccidentIconProps {
  className?: string;
  size?: number;
}

export const AccidentIcon: React.FC<AccidentIconProps> = ({ 
  className = '', 
  size = 150 
}) => {
  return (
    <svg 
      id="Layer_1" 
      xmlns="http://www.w3.org/2000/svg" 
      version="1.1" 
      viewBox="0 0 150 150"
      width={size}
      height={size}
      className={className}
    >
      <defs>
        <style>
          {`.st0 {
            fill: none;
            stroke: #e3e3e3;
            stroke-linecap: round;
            stroke-linejoin: round;
            stroke-width: 9px;
          }`}
        </style>
      </defs>
      <polyline className="st0" points="107.4 67.72 81.95 93.17 61.36 89.7 57.89 69.11 93.98 33.03"/>
      <line className="st0" x1="61.36" y1="89.7" x2="41.87" y2="109.19"/>
      <polygon className="st0" points="33.66 130.24 20.82 117.4 35.21 108.91 42.15 115.85 33.66 130.24"/>
      <line className="st0" x1="80.68" y1="67.72" x2="93.87" y2="80.9"/>
      <rect className="st0" x="82.84" y="32.54" width="57.5" height="13.86" rx="6.93" ry="6.93" transform="translate(60.59 -67.35) rotate(45)"/>
    </svg>
  );
};
